import { Button, DISABLE_BROWSER_AUTOFILL_SETTINGS, Icon, IconButton, TextField } from '@fox/atoms';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import { useAutoDataGridContext } from '../../auto-data-grid/context';

export function SearchBar(props) {
	const { search, setSearch } = useAutoDataGridContext();

	const theme = useTheme();
	const [isOpened, setIsOpened] = useState(false);

	const toggleIsOpened = async () => {
		setIsOpened(!isOpened);
		if (!isOpened) {
			await props.onExpand();
		} else {
			setSearch('');
			await props.onShrink();
		}
	};

	return (
		<>
			{isOpened && (
				<motion.div key="searchField" initial={{ opacity: 0, scale: 0.1 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }}>
					<TextField
						autoFocus
						value={search ?? ''}
						onChange={e => setSearch(e.target.value)}
						sx={{ width: 320 }}
						size="small"
						label="Only searches text columns"
						startAdornment={<Icon iconName="Search" />}
						inputProps={{ style: { paddingLeft: 5, paddingRight: 30 } }}
						endAdornment={<IconButton iconName="Close" title="Close" onClick={toggleIsOpened} style={{ position: 'absolute', right: 0 }} />}
						{...DISABLE_BROWSER_AUTOFILL_SETTINGS}
					/>
				</motion.div>
			)}
			{!isOpened && (
				<Button onClick={toggleIsOpened} startIcon={<Icon iconName={'Search'} />} style={{ color: theme.colors.font }}>
					Search
				</Button>
			)}
		</>
	);
}
